import { useEffect } from 'react'
import { bootstrap, startSync, stopSync } from '../../services/syncEngine'
import { useAuthStore } from '../../store/authStore'

export default function SyncCoordinator() {
  const { user, loading, needsImportDecision, syncDeferred, initialize } = useAuthStore()
  useEffect(() => { initialize() }, [initialize])
  useEffect(() => {
    if (loading) return
    if (!user) { stopSync(); return }
    if (needsImportDecision || syncDeferred) return
    bootstrap(user.id).then(startSync)
    return stopSync
  }, [user?.id, loading, needsImportDecision, syncDeferred])
  return null
}
